/* global require, $ */
import { RTE_TOKEN_ATTR } from '../constants';

export default function tokenDirective() {
  return {
    template: require('./token.html'),
    restrict: 'E',
    scope: {
      token: '<',
    },
    replace: true,
    link(scope, $el, attrs, ctrl) { // eslint-disable-line no-unused-vars
      $el.find('a')
        .on('dragstart', dragStart)
        .on('dragend', dragEnd);

      function dragStart($event) {
        $($event.target).fadeTo(0, 0.2);
        const data = $event.target.getAttribute(RTE_TOKEN_ATTR);
        // We include "RTE_TOKEN_ATTR=" in the token data
        // so we can verify its source in drop listeners
        $event.originalEvent.dataTransfer.setData('text', `${RTE_TOKEN_ATTR}=${data}`);
      }

      function dragEnd($event) {
        $($event.target).fadeTo('fast', 1);
      }
    }

  };
}
